import { StationDataManagementModel } from '../models/station-data-management';

export class StationDataManagementAdapter {
  static fromApi(data: any): StationDataManagementModel {
    return {
      id: data.id,
      identification: data.identification,
      hashId: data.hashId,
      temp: data.temp ?? null,
      tempMin: data.tempMin ?? null,
      tempMax: data.tempMax ?? null,
      humiMin: data.humiMin ?? null,
      humiMax: data.humiMax ?? null,
      wind: data.wind ?? null,
      windBurst: data.windBurst ?? null,
      rainAccum: data.rainAccum ?? null,
      humidity: data.humidity ?? null,
      radiation: data.radiation ?? null,
      evapo: data.evapo ?? null,
      pressure: data.pressure ?? null,
      generationDate: data.generationDate,
      creationDate: data.creationDate,
      stationId: data.stationId,
      stationIdentifier: data.stationIdentifier,
      dataSource: data.dataSource,
    };
  }
}
